import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Contact from "@/pages/Contact";
import LegalCheck from "@/pages/LegalCheck";
import Legal from "@/pages/Legal";
import MobileStickyBar from "@/components/MobileStickyBar";
import Login from "@/pages/portal/Login";
import Register from "@/pages/portal/Register";
import AdminLogin from "@/pages/portal/AdminLogin";
import SetPassword from "@/pages/SetPassword";
import ChannelPartnerRegistration from "@/pages/ChannelPartnerRegistration";
import BuyerPortal from "@/pages/portal/BuyerPortal";
import ChannelPartnerPortal from "@/pages/portal/ChannelPartnerPortal";
import BuilderPortal from "@/pages/portal/BuilderPortal";
import AdminDashboardV2 from "@/pages/portal/AdminDashboard";
import AuctionProperties from "@/pages/AuctionProperties";
import Brands from "@/pages/Brands";
import BrandDetail from "@/pages/BrandDetail";
import MediaCoverage from "@/pages/MediaCoverage";
import { LandProperties, DealerProperties } from "@/pages/LandDealerProperties";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/properties" element={<Properties />} />
                        <Route path="/properties/:slug" element={<PropertyDetail />} />
                        <Route path="/auction-properties" element={<AuctionProperties />} />
                        <Route path="/auction-properties/:slug" element={<PropertyDetail />} />
                        <Route path="/brands" element={<Brands />} />
                        <Route path="/about/media-coverage" element={<MediaCoverage />} />
                        <Route path="/land" element={<LandProperties />} />
                        <Route path="/dealer-properties" element={<DealerProperties />} />
                        <Route path="/brands/:slug" element={<BrandDetail />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/services/:slug" element={<ServiceDetail />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/insights" element={<Insights />} />
                        <Route path="/insights/:slug" element={<InsightDetail />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/legal-check" element={<LegalCheck />} />
                        {/* Policy / legal pages */}
                        <Route path="/privacy-policy"   element={<Legal />} />
                        <Route path="/terms-conditions" element={<Legal />} />
                        <Route path="/cookie-policy"    element={<Legal />} />
                        <Route path="/rera-disclaimer"  element={<Legal />} />
                        <Route path="/careers"          element={<Legal />} />
                        <Route path="/sitemap"          element={<Legal />} />
                        {/* Universal auth pages */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/admin" element={<AdminLogin />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/set-password" element={<SetPassword />} />
                        <Route path="/partner-registration" element={<ChannelPartnerRegistration />} />
                        <Route path="/channel-partner/register" element={<Navigate to="/partner-registration" replace />} />
                        {/* Portals */}
                        <Route path="/portal/buyer/*"    element={<BuyerPortal />} />
                        <Route path="/portal/partner/*"  element={<ChannelPartnerPortal />} />
                        <Route path="/portal/builder/*"  element={<BuilderPortal />} />
                        {/* Admin — old shorthand redirects to new dashboard */}
                        <Route path="/admin"            element={<Navigate to="/admin/dashboard" replace />} />
                        <Route path="/admin/login"      element={<Navigate to="/login?role=admin" replace />} />
                        <Route path="/admin/dashboard/*"  element={<AdminDashboardV2 />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <MobileStickyBar/>
                    <Toaster position="top-right" richColors theme="dark" />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
